import { render, staticRenderFns } from "./ReloadButton.vue?vue&type=template&id=12067408&scoped=true&"
import script from "./ReloadButton.vue?vue&type=script&lang=ts&"
export * from "./ReloadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12067408",
  null
  
)

export default component.exports